import { purple, violet } from "~/lib/ui";

export const WaveBackground: React.FC = () => (
  <svg
    className="absolute inset-0 w-full h-full object-cover"
    viewBox="0 0 1200 800"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
  >
    <defs>
      {/* Brand gradient definitions */}
      <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor={purple[500]} stopOpacity="0.9" />
        <stop offset="50%" stopColor={purple[600]} stopOpacity="0.7" />
        <stop offset="100%" stopColor={purple[700]} stopOpacity="0.6" />
      </linearGradient>

      <linearGradient id="grad2" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor={violet[400]} stopOpacity="0.8" />
        <stop offset="50%" stopColor={violet[500]} stopOpacity="0.6" />
        <stop offset="100%" stopColor={purple[400]} stopOpacity="0.5" />
      </linearGradient>

      <linearGradient id="grad3" x1="50%" y1="0%" x2="50%" y2="100%">
        <stop offset="0%" stopColor={purple[300]} stopOpacity="0.7" />
        <stop offset="50%" stopColor={violet[300]} stopOpacity="0.5" />
        <stop offset="100%" stopColor={purple[500]} stopOpacity="0.6" />
      </linearGradient>

      {/* Noise filter for grain texture */}
      <filter id="noiseFilter" x="0%" y="0%" width="100%" height="100%">
        <feTurbulence
          baseFrequency="0.9"
          numOctaves="1"
          stitchTiles="stitch"
          result="noise"
        />
        <feColorMatrix in="noise" type="saturate" values="0" />
        <feComponentTransfer in="noise" result="monoNoise">
          <feFuncA type="discrete" tableValues="0.1 0.05 0.15 0.2 0.1 0.05" />
        </feComponentTransfer>
        <feBlend in="SourceGraphic" in2="monoNoise" mode="multiply" />
      </filter>

      {/* Drop shadow filters */}
      <filter id="dropShadow1" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="2" dy="4" stdDeviation="6" floodOpacity="0.3" />
      </filter>

      <filter id="dropShadow2" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="4" dy="8" stdDeviation="12" floodOpacity="0.2" />
      </filter>
    </defs>

    {/* Base gradient background */}
    <rect width="100%" height="100%" fill="url(#grad1)" />

    {/* First wave layer */}
    <path
      d="M0,400 C300,320 600,480 900,400 C1050,360 1200,420 1200,420 L1200,800 L0,800 Z"
      fill="url(#grad2)"
      filter="url(#dropShadow1)"
      opacity="0.8"
    />

    {/* Second wave layer */}
    <path
      d="M0,500 C200,420 400,580 600,500 C800,420 1000,540 1200,480 L1200,800 L0,800 Z"
      fill="url(#grad3)"
      filter="url(#dropShadow2)"
      opacity="0.7"
    />

    {/* Third wave layer */}
    <path
      d="M0,600 C300,520 600,680 900,600 C1050,560 1200,620 1200,620 L1200,800 L0,800 Z"
      fill="url(#grad1)"
      opacity="0.4"
    />

    {/* Noise overlay */}
    <rect
      width="100%"
      height="100%"
      fill="white"
      opacity="0.02"
      filter="url(#noiseFilter)"
    />
  </svg>
);
